import { formatPrice } from '@/shared/lib/utils/price/format-price'

import { DolyameIcon } from './assets/dolyame-icon'
import { RightIcon } from './assets/right-icon'

import cl from './style.module.scss'

export interface DolyameButtonProps {
	onClick: () => void
	price?: number
}

export const DolyameButton = (props: DolyameButtonProps) => {
	const { onClick, price } = props

	return (
		<button className={cl.root} onClick={onClick}>
			<div className={cl.left}>
				<div className={cl.icon}>
					<DolyameIcon />
				</div>
				{price && <p className={cl.price}>4 платежа по {formatPrice(price)}</p>}
			</div>
			<RightIcon />
		</button>
	)
}
